import servicioBase from '@/services/servicio-base'

const servicioBolsaTrabajo = {}

servicioBolsaTrabajo.guardarCV = (formData) => {
    return servicioBase.post(`/publico/bolsa-trabajo/guardar-cv`, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(r => {
            return r.data
        })
        .catch(err => {
            console.log(err)
        })
}

servicioBolsaTrabajo.guardarSolicitud = (formData) => {
    return servicioBase.post(`/publico/bolsa-trabajo/guardar-solicitud-trabajo`, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(r => {
            return r.data
        })
        .catch(err => {
            console.log(err)
        })
}


export default servicioBolsaTrabajo
